import { useEffect, useState } from "react";
import en from "../../../lang/en-us";
import TextInput from "../../../lib/TextField";
import AddNominee from "./addNominee";
import * as yup from "yup";
import { NoteModals } from "../../../lib/NoteModals";
import { connect } from "react-redux";
import {
  getDate,
  getDateString,
  panRegex,
  _minDateForCalender,
} from "../../../utils/constants";
import { getNameIndex } from "../CorrectionFolios/correction-folios-selection";
import Image from "../../Image";

const {
  dashboard,
  signUp: { form },
  common,
} = en;

export interface InitialState {
  relation: string;
  name: string;
  mobile: string;
  email:string;
  idType:string;
  idNumber:string;
  dob: Date | string;
  share: number | null;
  address1: string;
  address2: string;
  address3?: string;
  pincode: number | string;
  city: string;
  state: string;
  country: string;
  guardianName: string;
  guardianPan: string;
  guardianAddress: string;
  guardianDob: Date | string;
  isEditable?: boolean;
  isNewlyAdded?: boolean;
  showDetails?: boolean;
  editShare?: boolean;
  id?: string;
  isEdited?: boolean;
}
export interface NOMINEEINFO extends InitialState {
  initialState?: InitialState;
}
export interface RELATIONS {
  label: string;
  value: string;
}
export const relationShips = [
  {
    label: "Mother",
    value: "mother",
  },
  {
    label: "Son",
    value: "son",
  },
  {
    label: "Daughter",
    value: "daughter",
  },
  {
    label: "Father",
    value: "father",
  },
  {
    label: "Spouse",
    value: "spouse",
  },
  {
    label: "Others",
    value: "others",
  },
];

export const initialValues: NOMINEEINFO = {
  relation: "",
  name: "",
  mobile:"",
  email:"",
  idType:"",
  idNumber:"",
  dob: "",
  share: null,
  address1: "",
  address2: "",
  pincode: "",
  city: "",
  state: "",
  country: "",
  guardianName: "",
  guardianPan: "",
  guardianAddress: "",
  guardianDob: "",
};

export const validationSchemaNominee = yup.object({
  relation: yup.string().required("Relation is required"),
  name: yup
    .string()
    .required("Name is required")
    .test("len", "Name is Required", (val) => val?.trim().length !== 0),
  gender: yup.string().required("Gender is required"),
  address1: yup
    .string()
    .notRequired()
    .test("len", common.spaceNotAllowed, (val) => val?.trim().length !== 0),
  address2: yup
    .string()
    .notRequired()
    .test("len", common.spaceNotAllowed, (val) => val?.trim().length !== 0),
  city: yup
    .string()
    .notRequired()
    .test("len", common.spaceNotAllowed, (val) => val?.trim().length !== 0)
    .max(50, common.cityMaxLength),
  state: yup
    .string()
    .notRequired()
    .test("len", common.spaceNotAllowed, (val) => val?.trim().length !== 0)
    .max(50, common.stateMaxLength),
  pincode: yup.string().length(6, "Pincode should be of 6 digits"),
  guardianPan: yup
    .string()
    .notRequired()
    .matches(panRegex, form.pan.validations.individualPan),
});

export default function NomineeSummary(props: any) {
  const { nomineesData = {}, noNomineeFlagAll = false } = props || {};
  const { nominees: data = [], investorName = "", verified } = nomineesData;
  const [nominees, setNominees] = useState<NOMINEEINFO[]>([]);

  useEffect(() => {
    setNominees(
      !!data.length
        ? data.slice(0, 3).map((_ele: any) => {
            let nomineeState = {
              relation: [
                "mother",
                "son",
                "daughter",
                "father",
                "spouse",
              ].includes(_ele?.relation?.toLowerCase())
                ? _ele.relation?.toLowerCase()
                : _ele.relation?.toLowerCase()
                ? "others"
                : "",
              name: _ele.name || "",
              dob: getDate(_ele.dob),
              share: _ele.percent,
              address1: _ele.address?.line1 || "",
              address2: _ele.address?.line2 || "",
              ..._ele?.address,
              guardianName: _ele.guardian?.name || "",
              guardianPan: _ele.guardian?.pan || "",
              guardianAddress: _ele.guardian?.address || "",
              guardianDob: _ele.guardian?.dob || "",
              isEditable: false,
              showDetails: false,
              editShare: false,
              isNewlyAdded: false,
              id: _ele.id,
              isEdited: false,
            };
            return { ...nomineeState, initialState: nomineeState };
          })
        : [
            {
              ...initialValues,
              isEditable: true,
              showDetails: false,
              editShare: false,
              isNewlyAdded: true,
              isEdited: false,
            },
          ]
    );
  }, []);

  // useEffect(() => {
  //     console.log('hhhagi');
  // }, [nominees]);

  return (
    <div
      className="curved-table-content update-nominee"
      style={{ boxShadow: "none", minHeight: "100px" }}
    >
      {nomineesData.noNominee === "Y" || noNomineeFlagAll ? (
        <div className="nominee-list">Opted out of nomination</div>
      ) : !nomineesData.noNominee && nomineesData.nominees.length === 0 ? (
        <div className="nominee-list">No nominees selected</div>
      ) : (
        nominees.map((_ele: NOMINEEINFO, index: number) => (
          <div className="nominee-list">
            <div className="nominee-list-single">
              <div className="nominee_name" style={{ marginRight: 7 }}>
                <span>
                  <Image src="/images/family-icon.svg" alt="icon" />
                </span>
                {getNameIndex(index + 1)} {dashboard.UpdateNominee.nomineeText}
              </div>
              <div className="nominee-detail-right">
                <div className="nominee-detail-top">
                  <div className="nominee_detail">
                    <p className="label"> {dashboard.UpdateNominee.name}</p>
                    <p className="value">{_ele.name} </p>
                  </div>
                  <div className="nominee_detail nominee_detail_relation">
                    <p className="label">{dashboard.UpdateNominee.relation}</p>
                    <p className="value">
                      {_ele.relation.slice(0, 1).toUpperCase() +
                        _ele.relation.slice(1)}
                    </p>
                  </div>
                  <div className="nominee_detail nominee_detail_share">
                    <>
                      <p className="label">{dashboard.UpdateNominee.share}</p>
                      <p className="value">{_ele.share}%</p>
                    </>
                  </div>
                  {/* <div className="nominee_detail_more">
                                <a>
                                    {dashboard.UpdateNominee.less}
                                    <img src="/images/up-arrow-purple.svg" alt="icon" />
                                </a>
                            </div> */}
                </div>
                {_ele.showDetails && (
                  <div className="nominee-detail-bottom">
                    <div className="nominee_detail nominee_detail_address">
                      <p className="label">
                        {" "}
                        {dashboard.UpdateNominee.address}
                      </p>
                      <p className="value">{_ele.address1}</p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        ))
      )}
    </div>
  );
}
